// 页面宽度适配，当页面宽度大于500时，html的fontSize最大设置为50px（即10%）
function adapt() {
  if (document.documentElement.clientWidth > 450) {
    document.documentElement.style.fontSize = '45px'
  } else {
    document.documentElement.style.fontSize = '10vw'
  }
}
adapt()

window.addEventListener('resize', () => {
  adapt()
})
